import * as React from "react";
import { Switch, Route } from "react-router-dom";

import LeftSideMenuRouter from "modules/project/components/layouts/LeftSideMenuRouter";
import { ProjectStore } from "modules/project/ProjectStore";
import { DevelopmentStore } from "modules/development/DevelopmentStore";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import { observer } from "mobx-react";
import CostPlan from "modules/costPlan/components/pages/CostPlan";
import Render3D from "modules/render3D/components/pages/Render3D";
import LayerTakeOff from "modules/takeOff/components/LayerTakeOff";
import UpdateBudgetResources from "modules/WBS/components/layouts/UpdateBudgetResources";
import TrialMessage from "modules/development/components/layouts/TrialMessage";
import UpdateCompositions from "modules/WBS/components/layouts/UpdateCompositions";
import UpdateCompositionsLoading from "modules/WBS/components/layouts/UpdateCompositionsLoading";
import { ELeftMenuTab } from "common/enums";

@observer
class Content extends React.Component {
  render() {
    let { developmentSelected } = DevelopmentStore,
      tabSelected = ProjectStore.leftTab !== ELeftMenuTab.CLOSED;
    return (
      <>
        <div style={{ position: "relative", display: "flex" }}>
          {tabSelected && (
            <>
              <div style={{ width: "250px", flexGrow: 1, maxWidth: "250px" }}>
                <LeftSideMenuRouter />
                <TrialMessage />
              </div>
            </>
          )}
          <UpdateCompositionsLoading />
          <UpdateCompositions />
          <UpdateBudgetResources />
          <div style={{ flexGrow: 2 }}>
            <Switch>
              <Route
                path={`/${developmentSelected.id}/WBS`}
                component={CostPlan}
              />
              <Route
                path={`/${developmentSelected.id}/viewer`}
                component={Render3D}
              />
            </Switch>
          </div>
          <MuiThemeProvider
            theme={createMuiTheme({ typography: { useNextVariants: true } })}
          >
            <LayerTakeOff />
          </MuiThemeProvider>
        </div>
      </>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/modules/project/components/layouts/Content.tsx